module.exports = __webpack_public_path__ + "static/media/resend.a858d5a5.svg";